import { IconListCheckboxOutline18 as ListChecks } from "nucleo-ui-outline-18"

import { ShortcutSymbols } from "@productlane/lib/src/shortcut-symbols"

import type { SlashCommandDefinition } from "../types"
import { iconClassName } from "../constants"

export const checklistCommand: SlashCommandDefinition = {
	key: "check-list",
	title: "Checklist",
	icon: <ListChecks strokeWidth={1.75} className={iconClassName} />,
	command: ({ editor, range }) => {
		editor.chain().focus().deleteRange(range).toggleTaskList().run()
	},
	group: "lists",
	shortcutIcons: [
		ShortcutSymbols.CMD,
		ShortcutSymbols.SHIFT,
		ShortcutSymbols[9],
	],
}
